/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});


// Toggle contacts (old way for contacts pages, removed after changes to structure)
/*
let contactsinfo = document.getElementsByClassName('contacts-change');
if (contactsinfo !== null) {
  
  let sisutuslasiBtn = document.querySelectorAll('.contacts-change .c-button')[0];
  let tuulilasiBtn = document.querySelectorAll('.contacts-change .c-button')[1];

  sisutuslasiBtn.addEventListener('click', function() { 
    this.classList.add('active');
    tuulilasiBtn.classList.remove('active');
    
    Array.from(document.getElementsByClassName('rakennus-ja-sisustuslasit')).forEach(function(element, index, array) { 
      if (element.classList.contains('is-layout-flex'))
        element.style.display = 'flex';
      else
        element.style.display = 'block';
    });
    
    Array.from(document.getElementsByClassName('tuulilasit')).forEach(function(element, index, array) {     
      element.style.display = 'none';  
    });

  });
  
  tuulilasiBtn.addEventListener('click', function() { 
    this.classList.add('active');
    sisutuslasiBtn.classList.remove('active');
    
    Array.from(document.getElementsByClassName('rakennus-ja-sisustuslasit')).forEach(function(element, index, array) { 
      element.style.display = 'none';  
    });
    
    Array.from(document.getElementsByClassName('tuulilasit')).forEach(function(element, index, array) {     
      if (element.classList.contains('is-layout-flex'))
        element.style.display = 'flex';
      else
        element.style.display = 'block';
    });
    
  });
  
   let clickEvent = new Event('click', {bubbles: true});
   document.querySelectorAll('.contacts-change .c-button')[0].dispatchEvent(clickEvent);

   // Check if there's a hashtag in url when page loaded
   let hash = window.location.hash.substr(1);
   if (hash == 'rakennus-ja-sisutuslasit') {
     // This is actually normally always active
     document.querySelectorAll('.contacts-change .c-button')[0].dispatchEvent(clickEvent);
   } else if (hash == 'tuulilasit') {
     // This is actually normally always active
     document.querySelectorAll('.contacts-change .c-button')[1].dispatchEvent(clickEvent);
   }
  
}
*/